import React from 'react'

import { CVQuality } from '../../../api/cv-roaster/types'
import { useI18N } from '../../../libraries/i18n/hook'

type Props = {  level: CVQuality, size?: 'sm' | 'md' }
const QualityChip: React.FC<Props> = ({ level, size = 'md' }) => {
  const { t } = useI18N()
  const getQualityColor = (quality: CVQuality): string => {
    switch (quality) {
      case 'high':
        return 'text-black bg-green-50'
      case 'mid':
        return 'text-black bg-yellow-50'
      case 'low':
        return 'text-black bg-red-50'
      default:
        return 'text-black bg-gray-50'
    }
  }

  const getQualityLabel = (quality: CVQuality): string => {
    switch (quality) {
      case 'high':
        return t('cv.quality.excellent')
      case 'mid':
        return t('cv.quality.good')
      case 'low':
        return t('cv.quality.needs.improvement')
      default:
        return 'Unknown'
    }
  }

  const label = getQualityLabel(level as CVQuality)
  const qualityColor = getQualityColor(level as CVQuality)

  const sizeClasses = size === 'sm' ? 'px-1 py-1 md:px-2 md:py-1 text-xs' : 'text-sm px-3 py-1 md:px-4 md:py-2'
  return (
    <div className={`inline-block rounded-full font-medium ${sizeClasses} ${qualityColor}`}>
      {label}
    </div>
  )
}

export default QualityChip
